module.exports = __webpack_public_path__ + "img/sass-thumb-1.7a17b205.png";